import React from 'react'
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import './style.scss'
import { checkIframeContent } from "../../../../../utils/common";

const BasketCard = (props) => {
    const {item, onInvestBasket} = props;
    
    return (
        <>
            <div className='card-body'>
                <div className='card-head'>
                    <div className='card-head-top'>
                        {/* <img className='card-icon' src='/images/screens_pending.svg' /> */}
                        <div class={`icon `+item.basketName}></div>
                        <div className='card-head-title'>{item.basketName}</div>
                    </div>
                    <p className='card-text'>{item.basketDescription}</p>
                </div>
                {checkIframeContent() ? <div className='basket-button'>
                    <a href={`/product-solutions/${item.basketName.replace(/\s+/g, '-').toLowerCase()}`} className='card-view-detail'>View Details</a>
                    <a onClick={() => onInvestBasket(item.basketName)} className='card-invest'>Invest Now</a>
                </div>: <div className='basket-button'>
                <Link
                    className="card-view-detail-iframe"
                    to={`/product-solutions/${item.basketName.replace(/\s+/g, '-').toLowerCase()}`}
                >
                    View Details
                </Link>
                </div>}
            </div>
        </>      
    )
}

export default BasketCard
